import React from "react";
import {Button} from "oneui";
import './style.scss'

const CommonButton = (props) => {
    const { dismissButton = false, theme, onClick, disabled, startIcon, children, ...other } = props;
    const classButton = dismissButton ? ((theme && theme.palette.type === "dark") ? 'dismiss-button-dark' : 'dismiss-button') : 'button';
    return (
        <div className={`${classButton} ${other.customClass}`}>
            <Button
                onClick={onClick}
                disabled={disabled}
                startIcon={startIcon}
                children={children}
                color={dismissButton ? 'secondary': 'primary'}
                {...other}
            />
        </div>
    )
};

export default CommonButton;